import { Controller, useFormContext } from 'react-hook-form';
import UniqueAutocomplete from '../Autocomplete/Autocomplete';
import { LegacyInput } from './Input';
import type { AutocompleteProps } from './types';
import { useValidation } from './useValidation';

function Autocomplete<T>({ registerControl, ...props }: AutocompleteProps<T>) {
  return registerControl ? (
    <RegisteredControl {...props} />
  ) : (
    <Controlled {...props} />
  );
}

export default Autocomplete;

function Controlled({
  label,
  name,
  margin,
  placeholder,
  variant,
  ...rest
}: any) {
  return (
    <UniqueAutocomplete
      disableVirtualization
      {...rest}
      renderInput={(params) => (
        <LegacyInput
          {...params}
          label={label}
          name={name}
          margin={margin}
          placeholder={placeholder}
          variant={variant}
        />
      )}
    />
  );
}

function RegisteredControl({
  label,
  name,
  margin,
  placeholder,
  variant,
  validation: validationBase,
  ...props
}: any) {
  const validation = useValidation(validationBase, { label });
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = name && errors[name];
  const helperText = error && (error.message || 'validation error');

  return (
    <Controller
      render={({ field: { onChange, ...rest } }) => (
        <UniqueAutocomplete
          disableVirtualization
          {...props}
          renderInput={(params) => (
            <LegacyInput
              {...params}
              label={label}
              margin={margin}
              placeholder={placeholder}
              variant={variant}
              error={Boolean(error)}
              helperText={helperText}
              validation={validation}
            />
          )}
          onChange={(e, data: any) => {
            onChange(data);
            props.onChange?.(e, data);
          }}
          {...rest}
        />
      )}
      control={control}
      name={name}
      rules={validation}
      defaultValue={null}
    />
  );
}
